import { useEffect, useState } from "react";
import { toastSuccess } from "../../../../components/base/Toast";
import DropDown from "../../../../components/form/DropDown";
import Form from "../../../../components/form/Form";
import { getUser, updatePreferences, useHub, usePreferences } from "../../../../core/Global";
import Icon from "../../../../components/base/Icon";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import { JobsPreferencesModel } from "../../../../models/AccountPreferences";
import FlexRow from "../../../../components/base/FlexRow";
import PhoneInput from "../../../../components/form/PhoneInput";
import { PaymentTypes } from "../../../../core/Enums";
import Checkbox from "../../../../components/form/Checkbox";
import TextArea from "../../../../components/form/TextArea";



export default function CRMJobBoardSettings() {

    const hub = useHub()
    const pref = usePreferences()
    const [working, workingSet] = useState<boolean>(false)
    const [body, bodySet] = useState<JobsPreferencesModel>({})

    useEffect(() => {
        if (pref) bodySet(pref.jobsPreferences);
    }, [pref])



    return (
        <Form className="form"
            onSubmit={(e, callback) => {
                workingSet(true);
                hub.Post("/system/Settings/jobpreferences", body, res => {
                    if (res.success) {
                        toastSuccess("Jobs preferences has been updated successfully!");
                        // The invoice screens read these defaults from the global preferences.
                        if (pref) updatePreferences({ ...pref, jobsPreferences: body });
                    }
                    if (callback) callback(res);
                    workingSet(false);
                });
            }}>
            <div className="card mb-5">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Jobs Preferences
                        </h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Preferences</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-4">

                    <ToggleSwitch label="Automatically fill customer details when a phone number is entered during job creation!"
                        name="autofillCustomerWhileAddJob" raw small className="mb-5"
                        checked={body.autofillCustomerWhileAddJob}
                        onChange={e => bodySet({
                            ...body,
                            autofillCustomerWhileAddJob: e
                        })} />

                    <ToggleSwitch label="Limit the technicians by 'Job Type' while creating a job!"
                        name="limitTechsByJobType" raw small className="mb-5"
                        checked={body.limitTechsByJobType}
                        onChange={e => bodySet({
                            ...body,
                            limitTechsByJobType: e
                        })} />

                    <ToggleSwitch label="Limit the technicians by 'Job Source' while creating a job!"
                        name="limitTechsByJobSource" raw small className="mb-5"
                        checked={body.limitTechsByJobSource}
                        onChange={e => bodySet({
                            ...body,
                            limitTechsByJobSource: e
                        })} />

                    <ToggleSwitch label="Limit the technicians by 'Metro' while creating a job!"
                        name="limitTechsByMetro" raw small className="mb-5"
                        checked={body.limitTechsByMetro}
                        onChange={e => bodySet({
                            ...body,
                            limitTechsByMetro: e
                        })} />

                    <ToggleSwitch label="Automatically move jobs to 'Submitted' when there is less than 1 hour to appointment!"
                        name="popupJobsToSubmitted" raw small className="mb-5"
                        checked={body.popupJobsToSubmitted}
                        onChange={e => bodySet({
                            ...body,
                            popupJobsToSubmitted: e
                        })} />

                    <ToggleSwitch label="When the appointment reminder is due and the job has not been sent to the technician yet, automatically send it as a new job for the technician to Accept or Reject!"
                        name="autoSendJobToTechOnApptReminder" raw small className="mb-5"
                        checked={body.autoSendJobToTechOnApptReminder}
                        onChange={e => bodySet({
                            ...body,
                            autoSendJobToTechOnApptReminder: e
                        })} />

                    <ToggleSwitch label="Automatically move jobs to 'In Progress' when technician accepted the job!"
                        name="moveToInProgressWhenTechAccept" raw small className="mb-5"
                        checked={body.moveToInProgressWhenTechAccept}
                        onChange={e => bodySet({
                            ...body,
                            moveToInProgressWhenTechAccept: e
                        })} />

                    <ToggleSwitch label="Automatically move jobs to 'In Progress' when the technician calls the customer via extension!"
                        name="moveToInProgressWhenTechCallsCustomer" raw small className="mb-5"
                        checked={body.moveToInProgressWhenTechCallsCustomer}
                        onChange={e => bodySet({
                            ...body,
                            moveToInProgressWhenTechCallsCustomer: e
                        })} />

                    <ToggleSwitch label="Enable the 'Start Job' / 'End Job' flow for technicians. After accepting a job, the technician gets a 'Start Job' button, then an 'End Job' button!"
                        name="enableTechStartEndJobFlow" raw small className="mb-5"
                        checked={body.enableTechStartEndJobFlow}
                        onChange={e => bodySet({
                            ...body,
                            enableTechStartEndJobFlow: e
                        })} />

                    {
                        body.enableTechStartEndJobFlow &&
                        <div className="ms-10">
                            <ToggleSwitch label="Automatically move jobs to 'In Progress' when the technician starts the job!"
                                name="moveToInProgressWhenTechStartsJob" raw small className="mb-5"
                                checked={body.moveToInProgressWhenTechStartsJob}
                                onChange={e => bodySet({
                                    ...body,
                                    moveToInProgressWhenTechStartsJob: e
                                })} />
                        </div>
                    }

                    <ToggleSwitch label="Automatically send 'Close Job' link when technician accepted the job!"
                        name="sendCloseJobLinkWhenTechAccept" raw small className="mb-5"
                        checked={body.sendCloseJobLinkWhenTechAccept}
                        onChange={e => bodySet({
                            ...body,
                            sendCloseJobLinkWhenTechAccept: e
                        })} />

                    <ToggleSwitch label="Allow technician to close the job directly with default rates!"
                        name="allowTechToCloseJobDirectly" raw small className="mb-5"
                        checked={body.allowTechToCloseJobDirectly}
                        onChange={e => bodySet({
                            ...body,
                            allowTechToCloseJobDirectly: e
                        })} />

                    <ToggleSwitch label="Force the agent to write a note when Updating or Removing the Technician!"
                        name="forceNoteOnUpdateTech" raw small className="mb-5"
                        checked={body.forceNoteOnUpdateTech}
                        onChange={e => bodySet({
                            ...body,
                            forceNoteOnUpdateTech: e
                        })} />

                    <ToggleSwitch label="Force the agent to write a note when Updating the payment of a Closed Job!"
                        name="forceNoteOnUpdatePayment" raw small className="mb-5"
                        checked={body.forceNoteOnUpdatePayment}
                        onChange={e => bodySet({
                            ...body,
                            forceNoteOnUpdatePayment: e
                        })} />

                    <ToggleSwitch label="Force the agent to choose a time range for job's appointment date!"
                        name="forceTimeRangeForAppt" raw small className="mb-5"
                        checked={body.forceTimeRangeForAppt}
                        onChange={e => bodySet({
                            ...body,
                            forceTimeRangeForAppt: e
                        })} />


                    <div className="w-500px mb-10">
                        <DropDown label="Default Range" block deselect={false}
                            defaultValue={body.defaultTimeRangeForAppt?.toString() ?? "1"}
                            onSelect={val => {
                                var id = Number.parseInt(val ?? "1");
                                if (isNaN(id)) id = 1;
                                bodySet({
                                    ...body,
                                    defaultTimeRangeForAppt: id
                                })
                            }}
                            source={[
                                {
                                    id: "1",
                                    name: "1 Hour (10:00 - 11:00)"
                                },
                                {
                                    id: "2",
                                    name: "2 Hours (10:00 - 12:00)"
                                },
                                {
                                    id: "3",
                                    name: "3 Hours (10:00 - 13:00)"
                                },
                                {
                                    id: "4",
                                    name: "4 Hours (10:00 - 14:00)"
                                }
                            ]} />
                    </div>



                    <ToggleSwitch label="Automatically send a copy of new jobs via SMS to an external number!"
                        name="sendNewJobsToSMS" raw small className="mb-5"
                        checked={body.sendNewJobsToSMS}
                        onChange={e => bodySet({
                            ...body,
                            sendNewJobsToSMS: e
                        })} />

                    {
                        body.sendNewJobsToSMS &&
                        <FlexRow>
                            <div className="w-300px me-5">
                                <PhoneInput id="send-jobs-sms-1" key="send-jobs-sms-1" defaultPhone={body.smsNumber1}
                                    countryCodes="us-only" label="Phone Number 1" labelUp block
                                    onComplete={e => bodySet({
                                        ...body,
                                        smsNumber1: e
                                    })}
                                    onInComplete={() => bodySet({
                                        ...body,
                                        smsNumber1: undefined
                                    })}
                                />
                            </div>
                            <div className="w-300px me-5">
                                <PhoneInput id="send-jobs-sms-2" key="send-jobs-sms-2" defaultPhone={body.smsNumber2}
                                    countryCodes="us-only" label="Phone Number 2" labelUp block
                                    onComplete={e => bodySet({
                                        ...body,
                                        smsNumber2: e
                                    })}
                                    onInComplete={() => bodySet({
                                        ...body,
                                        smsNumber2: undefined
                                    })}
                                />
                            </div>
                            <div className="w-300px">
                                <PhoneInput id="send-jobs-sms-3" key="send-jobs-sms-3" defaultPhone={body.smsNumber3}
                                    countryCodes="us-only" label="Phone Number 3" labelUp block
                                    onComplete={e => bodySet({
                                        ...body,
                                        smsNumber3: e
                                    })}
                                    onInComplete={() => bodySet({
                                        ...body,
                                        smsNumber3: undefined
                                    })}
                                />
                            </div>
                        </FlexRow>
                    }

                    <ToggleSwitch label="Automatically send a copy of new jobs to a WhatsApp number!"
                        name="sendNewJobsToWhatsApp" raw small className="mb-5"
                        checked={body.sendNewJobsToWhatsApp}
                        onChange={e => bodySet({
                            ...body,
                            sendNewJobsToWhatsApp: e
                        })} />

                    {
                        body.sendNewJobsToWhatsApp &&
                        <FlexRow>
                            <div className="w-300px me-5">
                                <PhoneInput id="send-jobs-wa-1" key="send-jobs-wa-1" defaultPhone={body.waNumber1}
                                    countryCodes="all" label="WhatsApp Number 1" labelUp block
                                    onComplete={e => bodySet({
                                        ...body,
                                        waNumber1: e
                                    })}
                                    onInComplete={() => bodySet({
                                        ...body,
                                        waNumber1: undefined
                                    })}
                                />
                            </div>
                            <div className="w-300px me-5">
                                <PhoneInput id="send-jobs-wa-2" key="send-jobs-wa-2" defaultPhone={body.waNumber2}
                                    countryCodes="all" label="WhatsApp Number 2" labelUp block
                                    onComplete={e => bodySet({
                                        ...body,
                                        waNumber2: e
                                    })}
                                    onInComplete={() => bodySet({
                                        ...body,
                                        waNumber2: undefined
                                    })}
                                />
                            </div>
                            <div className="w-300px">
                                <PhoneInput id="send-jobs-wa-3" key="send-jobs-wa-3" defaultPhone={body.waNumber3}
                                    countryCodes="all" label="WhatsApp Number 3" labelUp block
                                    onComplete={e => bodySet({
                                        ...body,
                                        waNumber3: e
                                    })}
                                    onInComplete={() => bodySet({
                                        ...body,
                                        waNumber3: undefined
                                    })}
                                />
                            </div>
                        </FlexRow>
                    }


                    <ToggleSwitch label="Require customer approval for job invoices!"
                        name="jobInvoiceAcceptRequired" raw small className="mb-5"
                        checked={body.jobInvoiceAcceptRequired}
                        onChange={e => bodySet({
                            ...body,
                            jobInvoiceAcceptRequired: e
                        })} />

                    <ToggleSwitch label="Require customer signature for job invoices!"
                        name="jobInvoiceSignatureRequired" raw small className="mb-5"
                        checked={body.jobInvoiceSignatureRequired}
                        onChange={e => bodySet({
                            ...body,
                            jobInvoiceSignatureRequired: e
                        })} />

                    <ToggleSwitch label="Include customer phone number in job invoices!"
                        name="jobInvoiceShowCustomerPhone" raw small className="mb-5"
                        checked={body.jobInvoiceShowCustomerPhone ?? true}
                        onChange={e => bodySet({
                            ...body,
                            jobInvoiceShowCustomerPhone: e
                        })} />


                    <div className="mb-5">
                        <TextArea label="Invoice disclaimer" labelUp block rows={3}
                            name="jobInvoiceDisclaimer"
                            placeholder="What the customer agrees to when they sign — shown above the signature"
                            value={body.jobInvoiceDisclaimer}
                            onChange={e => bodySet({
                                ...body,
                                jobInvoiceDisclaimer: e.target.value
                            })} />
                    </div>

                    {/*
                        Tip options are not offered here for now — every account gets the three
                        the app offers by default. `jobInvoiceTipPercents` is still on the
                        preferences and still read: an empty list is what means "the default", so
                        nothing had to change behind this to take the field away.
                    */}

                    <ToggleSwitch label="Allow all available payment types when closing a job!"
                        name="useAllPaymentTypesOnCloseJob" raw small className="mb-5"
                        checked={body.useAllPaymentTypesOnCloseJob}
                        onChange={e => bodySet({
                            ...body,
                            useAllPaymentTypesOnCloseJob: e
                        })} />

                    {
                        !body.useAllPaymentTypesOnCloseJob &&
                        <FlexRow wrap className="bg-light-secondary p-3 pt-5">
                            {
                                Object.entries(PaymentTypes)
                                    .filter(([key, value]) => isNaN(Number(key)) && value !== PaymentTypes.None)
                                    .map(([key, value]) =>
                                        <Checkbox key={`toggle-payment-type-${value}-${key}`}
                                            label={key} className="me-10 mb-5"
                                            checked={body.limitedPaymentTypes?.includes(value as PaymentTypes)}
                                            onChange={chk => {
                                                bodySet(prev => {
                                                    const list = prev.limitedPaymentTypes ?? [];
                                                    const type = value as PaymentTypes;
                                                    const next = chk
                                                        ? (list.includes(type) ? list : [...list, type])
                                                        : list.filter(x => x !== type);

                                                    return { ...prev, limitedPaymentTypes: next };
                                                })
                                            }}
                                        />
                                    )
                            }
                        </FlexRow>
                    }





                </div>
            </div>
        </Form>
    )
}